module.exports = __webpack_public_path__ + "static/media/clinician-balancing-video-thumbnail.e4be0438.png";